import { render, staticRenderFns } from "./FreebiesListPage.vue?vue&type=template&id=1a475362"
import script from "./FreebiesListPage.vue?vue&type=script&lang=js"
export * from "./FreebiesListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports